import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import "./Sidenav.css";

interface SidenavProps {
    onToggleSideNav: (collapsed: boolean, screenWidth: number) => void;
    navigationItems: { to: string, icon: string, text: string }[];
}

const Sidenav: React.FC<SidenavProps> = ({ onToggleSideNav, navigationItems }) => {
    const [collapsed, setCollapsed] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [burgerMenuOpen, setBurgerMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
            if (window.innerWidth > 600) setBurgerMenuOpen(false);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        onToggleSideNav(collapsed, screenWidth);
    }, [collapsed, screenWidth, onToggleSideNav]);

    const toggleBurgerMenu = () => {
        setBurgerMenuOpen((prev) => !prev);
    };

    return (
        <>
            {screenWidth <= 600 && (
                <div className="burger-icon" onClick={toggleBurgerMenu}>
                    <span className="material-icons">
                        {burgerMenuOpen ? "close" : "menu"}
                    </span>
                </div>
            )}
            {burgerMenuOpen && screenWidth <= 600 && (
                <div className="burger-menu">
                    <ul className="burger-menu-nav">
                        {navigationItems.map(({ to, icon, text }) => (
                            <li
                                key={to}
                                className={`burger-menu-nav-item ${
                                    location.pathname === to ? "active" : ""
                                }`}
                            >
                                <Link
                                    className="burger-menu-nav-link"
                                    to={to}
                                    aria-label={text}
                                    onClick={() => setBurgerMenuOpen(false)}
                                >
                                    <span className="material-icons burger-menu-link-icon">
                                        {icon}
                                    </span>
                                    <span className="burger-menu-link-text">{text}</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
            {screenWidth > 600 && (
                <nav
                    className={`sidenav ${collapsed ? "sidenav-collapsed" : ""}`}
                    role="navigation"
                >
                    <ul className="sidenav-nav">
                        {navigationItems.map(({to, icon, text}) => (
                            <li
                                key={to}
                                className={`sidenav-nav-item ${
                                    location.pathname === to ? "active" : ""
                                }`}
                            >
                                <Link
                                    className="sidenav-nav-link"
                                    to={to}
                                    aria-label={text}
                                >
                                    <span className="material-icons sidenav-link-icon">
                                        {icon}
                                    </span>
                                    <span className="sidenav-link-text">{text}</span>
                                </Link>
                            </li>
                        ))}
                        <div className="expand-container">
                            <div className="logo" onClick={() => setCollapsed((prev) => !prev)}>
                                {collapsed ? (
                                    <span className="material-icons sidenav-link-icon">
                                    arrow_back_ios
                                </span>
                                ) : (
                                    <span className="material-icons sidenav-link-icon">
                                    arrow_forward_ios
                                </span>
                                )}
                            </div>
                            <span className="logo-text">ESCONDER</span>
                        </div>
                    </ul>
                </nav>
            )}
        </>
    );
};

export default Sidenav;